var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.899181 13.1797C0.409044 13.1797 0.0117188 13.5771 0.0117188 14.0671V27.1018C0.0117188 27.592 0.409102 27.9893 0.899181 27.9893H6.24605V13.1797H0.899181Z",
    fill: "#121933",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9894 18.0813C29.9894 16.9547 29.3841 15.9668 28.4816 15.4258C28.8274 14.9265 29.0302 14.3208 29.0302 13.6688C29.0302 11.963 27.6423 10.5751 25.9365 10.5751H19.4057C19.6059 9.6681 19.8796 8.30703 20.0703 6.8822C20.5663 3.17432 20.2273 1.11797 19.0034 0.410805C18.2404 -0.0299959 17.4178 -0.11941 16.687 0.158793C16.1224 0.373833 15.36 0.902525 14.9255 2.20008L13.2091 6.69429C12.3389 8.84334 9.67412 11.0995 8.02148 12.347V28.3829C11.0844 29.4561 14.2806 30 17.5413 30H24.6573C26.3632 30 27.751 28.6122 27.751 26.9063C27.751 26.309 27.5808 25.7506 27.2864 25.2772C28.3177 24.7749 29.0301 23.7159 29.0301 22.4938C29.0301 21.8418 28.8273 21.2362 28.4815 20.7369C29.3841 20.1958 29.9894 19.2079 29.9894 18.0813Z",
    fill: "#121933",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLike);
export default __webpack_public_path__ + "static/media/faq_like.3a3692d4812cf9b06bbd7860d1db7589.svg";
export { ForwardRef as ReactComponent };